export function sortByKey(array, key) {
    return array?.slice().sort(function (a, b) {
        return a?.[key] - b?.[key];
    });
}
